import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
  ArrowRight,
  BadgeDollarSign,
  ClipboardList,
  Mic2,
  ScanSearch,
  ScrollText,
  Workflow,
} from "lucide-react";
import { Link } from "react-router-dom";

const featureCards = [
  {
    title: "Interview Practice",
    lead: "Practice interviews tailored to you",
    sub: "Train with realistic questions based on your background, your industry, and the job.",
    icon: Mic2,
    accent: "from-sky-500 to-cyan-400",
  },
  {
    title: "Story & Pitch Coaching",
    lead: "Turn your experience into a clear, confident story",
    sub: "Learn to talk about your experience and relate it back to any role you're applying to.",
    icon: ScrollText,
    accent: "from-violet-500 to-fuchsia-400",
  },
  {
    title: "Job Tracking",
    lead: "Track your search without losing momentum",
    sub: "Keep applications, follow-ups, and next steps in one place.",
    icon: ClipboardList,
    accent: "from-emerald-500 to-teal-400",
  },
  {
    title: "Custom Resumes",
    lead: "Tailor every application to the role",
    sub: "Write a resume that highlights your experience and skills for each role you apply to, without the headache.",
    icon: ScanSearch,
    accent: "from-amber-500 to-orange-400",
  },
  {
    title: "Salary Negotiations",
    lead: "Practice the salary conversation and earn more money",
    sub: "The most difficult - and important - conversation you'll have in your job search deserves some practice.",
    icon: BadgeDollarSign,
    accent: "from-rose-500 to-orange-400",
  },
  {
    title: "End-to-End System",
    lead: "One system for your entire job search",
    sub: "From application to offer, everything stays organized and actionable.",
    icon: Workflow,
    accent: "from-slate-700 to-slate-500",
  },
];

export function LandingFeaturesMain() {
  return (
    <section id="features" className="bg-[#fffaf2] py-20">
      <div className="container mx-auto px-6">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.28em] text-[#b96b24]">
            "OK, great - but what can you do for me?"
          </p>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-slate-900 md:text-4xl">
            Great question.<br/> Here's what we'll do for you:
          </h2>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
          {featureCards.map((feature) => {
            const Icon = feature.icon;

            return (
              <Card
                key={feature.title}
                className="group overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-slate-200"
              >
                <CardContent className="p-7">
                  <div className="flex justify-center">
                    <div
                      className={`inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br ${feature.accent} text-white shadow-lg`}
                      aria-hidden
                    >
                      <Icon className="h-7 w-7" strokeWidth={1.75} />
                    </div>
                  </div>
                  <h3 className="mt-6 text-center text-lg font-bold leading-snug text-slate-900">
                    {feature.title}
                  </h3>
                  <div className="mt-2 space-y-1.5 text-left">
                    <p className="text-base font-semibold leading-snug text-slate-900">
                      {feature.lead}
                    </p>
                    <p className="text-sm leading-relaxed text-slate-600 md:text-[15px]">
                      {feature.sub}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-10 flex flex-col items-center gap-3 text-center">
          <Button asChild className="h-14 rounded-full bg-[#334763] px-8 text-base font-semibold text-white hover:bg-[#243247]">
            <Link to="/register">
              Get started for free
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}

export default LandingFeaturesMain;
